import { useTranslation } from "react-i18next";

import { Spinner } from "@/components/ui/spinner";

/**
 * Suspense fallback for lazy-loaded routes. Stays neutral — doesn't mock
 * any specific layout (AppShell, kiosk, onboarding) so it never flashes a
 * mismatched skeleton. Lazy chunks are 3–15 KB gzipped, so the visible
 * window is brief.
 */
export function PageSkeleton() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-page">
      <Spinner size="lg" label={t("common.loading")} />
    </div>
  );
}
